import React, { useEffect, useState } from "react";

console.log("outside the funciton ")


function GetBatchesVk() {
    console.log("1 outside the funciton  ")

    const [data, setdata] = useState("2 data value is 2")

    console.log(data)

    useEffect(() => {
        console.log("3 inside use effect ");
    }, [])

    return (
        <>
            {console.log("4 insde Retrun")}
            <div style={{ padding: "50px", textAlign: "center" }}>
                <h2>Users List</h2>
            </div>
        </>

    );
}

console.log("5 -last out side the funciton  ");


export default GetBatchesVk;


// import React, { useEffect } from "react";
// import useApi from "../API/useApi";


// function GetBatchesVk() {
//     const {
//         data: usersData,
//         loading: usersLoading,
//         error: usersError,
//         callApi: getUsers,
//     } = useApi("https://jsonplaceholder.typicode.com/users", {
//         method: "GET",
//         autoCall: false, // disable automatic call
//     });

//     useEffect(() => {
//         getUsers(); // manually call the API
//     }, []);

//     useEffect(() => {
//         console.log(usersData, "Users Data");
//     }, [usersData]);

//     return (
//         <div style={{ padding: "50px", textAlign: "center" }}>
//             <h2>Users List</h2>

//             {usersLoading && <p>Loading...</p>}
//             {usersError && <p style={{ color: "red" }}>{usersError}</p>}

//             <ul>
//                 {usersData?.map((user: any) => (
//                     <li key={user.id}>
//                         {user.name} ({user.email})
//                     </li>
//                 ))}
//             </ul>
//         </div>
//     );
// }

// export default GetBatchesVk;
